import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { delay, retry } from 'rxjs/operators';
import { TestService } from 'src/app/services/test.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'ct-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FeedbackComponent implements OnInit {

  @ViewChild('feedbackModal') feedbackModal;

  modalRef: NgbModalRef;
  closeResult: string;

  feedbackForm: FormGroup = this.fb.group({
    score: [null, Validators.required],
    comment: [],
  });

  constructor(
    public modal: NgbModal,
    private fb: FormBuilder,
    private testService: TestService,
    private activatedRoute: ActivatedRoute,
    private utilsService: UtilsService
  ) { }

  ngOnInit(): void { }

  openModal() {
    if (!this.modal.hasOpenModals()) {
      this.modalRef = this.modal.open(this.feedbackModal, { ariaLabelledBy: 'Eliminar-Proceso', size: 'l', centered: true });
      this.modalRef.result.then((result) => {
        this.closeResult = 'Closed with: ' + result;
      }, (reason) => {
        // this.closeResult = 'Dismissed ' + this.getDismissReason(reason);
      });
    }
  }

  onSubmit() {
    if (this.feedbackForm.valid) {
      const testToken = this.activatedRoute.snapshot.queryParamMap.get('testToken');
      this.testService.sendFeedback(testToken, this.feedbackForm.value).pipe(
        // Segundo y tercer intento con retardo de 1000ms
        retry(2), delay(1000)
      ).subscribe(
        res => { this.modalRef.close(); this.utilsService.toast('success', 'Feedback') },
        err => this.utilsService.toast('error', 'Feedback')
      );
    }
  }

}
